import {
  captureStack1fzi4aczwc4hg as captureStack,
  createExternalThis2k2orr8ix0ytc as createExternalThis,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  setupCauseParameter20kc7dphipdif as setupCauseParameter,
  toString1pkumu07cwy4m as toString,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from './Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_UnsupportedOperationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var UnsupportedOperationExceptionClass;
function UnsupportedOperationException() {
  if (UnsupportedOperationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_UnsupportedOperationException_cv3bvm_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
      static new_kotlin_UnsupportedOperationException_chzcdl_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsupportedOperationException', $.new_kotlin_UnsupportedOperationException_cv3bvm_k$);
    UnsupportedOperationExceptionClass = $;
  }
  return UnsupportedOperationExceptionClass;
}
function init_kotlin_IllegalArgumentException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var IllegalArgumentExceptionClass;
function IllegalArgumentException() {
  if (IllegalArgumentExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_IllegalArgumentException_pv5o3f_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static new_kotlin_IllegalArgumentException_sfqr8_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static new_kotlin_IllegalArgumentException_afpr0i_k$(message, cause) {
        var $this = this.new_kotlin_RuntimeException_iani9z_k$(message, cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static new_kotlin_IllegalArgumentException_8emk6d_k$(cause) {
        var $this = this.new_kotlin_RuntimeException_q30ov4_k$(cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalArgumentException', $.new_kotlin_IllegalArgumentException_pv5o3f_k$);
    IllegalArgumentExceptionClass = $;
  }
  return IllegalArgumentExceptionClass;
}
function init_kotlin_RuntimeException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_2);
}
var RuntimeExceptionClass;
function RuntimeException() {
  if (RuntimeExceptionClass === VOID) {
    class $ extends Exception() {
      static new_kotlin_RuntimeException_29f9zq_k$() {
        var $this = this.new_kotlin_Exception_f32mds_k$();
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static new_kotlin_RuntimeException_xu1s8h_k$(message) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static new_kotlin_RuntimeException_iani9z_k$(message, cause) {
        var $this = this.new_kotlin_Exception_9qyiel_k$(message, cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static new_kotlin_RuntimeException_q30ov4_k$(cause) {
        var $this = this.new_kotlin_Exception_bock1m_k$(cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'RuntimeException', $.new_kotlin_RuntimeException_29f9zq_k$);
    RuntimeExceptionClass = $;
  }
  return RuntimeExceptionClass;
}
function init_kotlin_Exception(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_1);
}
var ExceptionClass;
function Exception() {
  if (ExceptionClass === VOID) {
    class $ extends Error {
      static new_kotlin_Exception_f32mds_k$() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Exception($this);
        return $this;
      }
      static new_kotlin_Exception_hsqbop_k$(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Exception($this);
        return $this;
      }
      static new_kotlin_Exception_9qyiel_k$(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Exception($this);
        return $this;
      }
      static new_kotlin_Exception_bock1m_k$(cause) {
        var $this = createExternalThis(this, Error, [null, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, VOID, cause);
        init_kotlin_Exception($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Exception', $.new_kotlin_Exception_f32mds_k$);
    ExceptionClass = $;
  }
  return ExceptionClass;
}
function init_kotlin_NoSuchElementException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var NoSuchElementExceptionClass;
function NoSuchElementException() {
  if (NoSuchElementExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_NoSuchElementException_wy3d4q_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
      static new_kotlin_NoSuchElementException_eborbh_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoSuchElementException', $.new_kotlin_NoSuchElementException_wy3d4q_k$);
    NoSuchElementExceptionClass = $;
  }
  return NoSuchElementExceptionClass;
}
function init_kotlin_IndexOutOfBoundsException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var IndexOutOfBoundsExceptionClass;
function IndexOutOfBoundsException() {
  if (IndexOutOfBoundsExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_IndexOutOfBoundsException_cc7xqw_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
      static new_kotlin_IndexOutOfBoundsException_ddr8db_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IndexOutOfBoundsException', $.new_kotlin_IndexOutOfBoundsException_cc7xqw_k$);
    IndexOutOfBoundsExceptionClass = $;
  }
  return IndexOutOfBoundsExceptionClass;
}
function init_kotlin_IllegalStateException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var IllegalStateExceptionClass;
function IllegalStateException() {
  if (IllegalStateExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_IllegalStateException_1wtnp1_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static new_kotlin_IllegalStateException_w47ei6_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static new_kotlin_IllegalStateException_z3fz2g_k$(message, cause) {
        var $this = this.new_kotlin_RuntimeException_iani9z_k$(message, cause);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalStateException', $.new_kotlin_IllegalStateException_1wtnp1_k$);
    IllegalStateExceptionClass = $;
  }
  return IllegalStateExceptionClass;
}
function init_kotlin_ConcurrentModificationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var ConcurrentModificationExceptionClass;
function ConcurrentModificationException() {
  if (ConcurrentModificationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_ConcurrentModificationException_fy07nh_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
      static new_kotlin_ConcurrentModificationException_snpq2y_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentModificationException', $.new_kotlin_ConcurrentModificationException_fy07nh_k$);
    ConcurrentModificationExceptionClass = $;
  }
  return ConcurrentModificationExceptionClass;
}
function init_kotlin_ArithmeticException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var ArithmeticExceptionClass;
function ArithmeticException() {
  if (ArithmeticExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_ArithmeticException_t7nj4q_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_ArithmeticException($this);
        return $this;
      }
      static new_kotlin_ArithmeticException_y2sjkx_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_ArithmeticException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ArithmeticException', $.new_kotlin_ArithmeticException_t7nj4q_k$);
    ArithmeticExceptionClass = $;
  }
  return ArithmeticExceptionClass;
}
function init_kotlin_ClassCastException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var ClassCastExceptionClass;
function ClassCastException() {
  if (ClassCastExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_ClassCastException_zhuhe1_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_ClassCastException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ClassCastException', $.new_kotlin_ClassCastException_zhuhe1_k$);
    ClassCastExceptionClass = $;
  }
  return ClassCastExceptionClass;
}
function init_kotlin_Error(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_1);
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ extends Error {
      static new_kotlin_Error_8ce653_k$() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Error($this);
        return $this;
      }
      static new_kotlin_Error_cvq542_k$(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Error($this);
        return $this;
      }
      static new_kotlin_Error_aez7v8_k$(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Error($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Error', $.new_kotlin_Error_8ce653_k$);
    ErrorClass = $;
  }
  return ErrorClass;
}
function init_kotlin_NumberFormatException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_4);
}
var NumberFormatExceptionClass;
function NumberFormatException() {
  if (NumberFormatExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static new_kotlin_NumberFormatException_rswu7k_k$() {
        var $this = this.new_kotlin_IllegalArgumentException_pv5o3f_k$();
        init_kotlin_NumberFormatException($this);
        return $this;
      }
      static new_kotlin_NumberFormatException_hv2a95_k$(message) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(message);
        init_kotlin_NumberFormatException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NumberFormatException', $.new_kotlin_NumberFormatException_rswu7k_k$);
    NumberFormatExceptionClass = $;
  }
  return NumberFormatExceptionClass;
}
function init_kotlin_AssertionError(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_2);
}
var AssertionErrorClass;
function AssertionError() {
  if (AssertionErrorClass === VOID) {
    class $ extends Error_0() {
      static new_kotlin_AssertionError_h2eae3_k$() {
        var $this = this.new_kotlin_Error_8ce653_k$();
        init_kotlin_AssertionError($this);
        return $this;
      }
      static new_kotlin_AssertionError_kql36u_k$(message) {
        var tmp = message == null ? null : toString(message);
        var $this = this.new_kotlin_Error_aez7v8_k$(tmp, message instanceof Error ? message : null);
        init_kotlin_AssertionError($this);
        return $this;
      }
    }
    initMetadataForClass($, 'AssertionError', $.new_kotlin_AssertionError_h2eae3_k$);
    AssertionErrorClass = $;
  }
  return AssertionErrorClass;
}
function init_kotlin_UninitializedPropertyAccessException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var UninitializedPropertyAccessExceptionClass;
function UninitializedPropertyAccessException() {
  if (UninitializedPropertyAccessExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_UninitializedPropertyAccessException_l975ei_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
      static new_kotlin_UninitializedPropertyAccessException_egi92l_k$(message) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(message);
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UninitializedPropertyAccessException', $.new_kotlin_UninitializedPropertyAccessException_l975ei_k$);
    UninitializedPropertyAccessExceptionClass = $;
  }
  return UninitializedPropertyAccessExceptionClass;
}
function init_kotlin_NoWhenBranchMatchedException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var NoWhenBranchMatchedExceptionClass;
function NoWhenBranchMatchedException() {
  if (NoWhenBranchMatchedExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_NoWhenBranchMatchedException_9ooqm1_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_NoWhenBranchMatchedException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoWhenBranchMatchedException', $.new_kotlin_NoWhenBranchMatchedException_9ooqm1_k$);
    NoWhenBranchMatchedExceptionClass = $;
  }
  return NoWhenBranchMatchedExceptionClass;
}
function init_kotlin_NullPointerException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var NullPointerExceptionClass;
function NullPointerException() {
  if (NullPointerExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlin_NullPointerException_q6jd54_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlin_NullPointerException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NullPointerException', $.new_kotlin_NullPointerException_q6jd54_k$);
    NullPointerExceptionClass = $;
  }
  return NullPointerExceptionClass;
}
//region block: exports
export {
  ArithmeticException as ArithmeticException18dajwq7kbp38,
  AssertionError as AssertionError3yq7q0knw9m5,
  ClassCastException as ClassCastException1atiay3nqgbd,
  ConcurrentModificationException as ConcurrentModificationException3974vl9oonkcj,
  Error_0 as Error3ofk6owajcepa,
  Exception as Exceptiondt2hlxn7j7vw,
  IllegalArgumentException as IllegalArgumentException2asla15b5jaob,
  IllegalStateException as IllegalStateExceptionkoljg5n0nrlr,
  IndexOutOfBoundsException as IndexOutOfBoundsException1qfr429iumro0,
  NoSuchElementException as NoSuchElementException679xzhnp5bpj,
  NoWhenBranchMatchedException as NoWhenBranchMatchedException3krrgsc7u48pz,
  NullPointerException as NullPointerException3mu0rhxjjitqq,
  NumberFormatException as NumberFormatException3bgsm2s9o4t55,
  RuntimeException as RuntimeException1r3t0zl97011n,
  UninitializedPropertyAccessException as UninitializedPropertyAccessException8qin22n38p0w,
  UnsupportedOperationException as UnsupportedOperationException2tkumpmhredt3,
};
//endregion

//# sourceMappingURL=exceptions.mjs.map
